module.exports = __webpack_public_path__ + "static/img/press6.d21a494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press6.png
// module id = 3OLM
// module chunks = 0